import { PageHeader } from "@/components/PageHeader";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { AnnouncementListTab } from "./AnnouncementListTab";
import { AnnouncementCreateTab } from "./AnnouncementCreateTab";

type TabId = "list" | "create";

const TABS: { id: TabId; label: string }[] = [
  { id: "list", label: "Announcements" },
  { id: "create", label: "Create New" },
];

export function AnnouncementsPage() {
  const [activeTab, setActiveTab] = useState<TabId>("list");

  const handleCreated = () => {
    setActiveTab("list");
  };

  return (
    <div className="px-4 py-0">
      <PageHeader
        title="Announcements"
        subtitle="Manage announcement emails and broadcast to users"
      />

      {/* Tab navigation */}
      <div className="mb-6 border-b border-zinc-200 dark:border-zinc-700">
        <nav className="-mb-px flex gap-6">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                "border-b-2 pb-3 text-sm font-medium transition-colors",
                activeTab === tab.id
                  ? "border-blue-500 text-blue-600 dark:text-blue-400"
                  : "border-transparent text-zinc-500 hover:border-zinc-300 hover:text-zinc-700 dark:text-zinc-400 dark:hover:text-zinc-300"
              )}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab content */}
      {activeTab === "list" && <AnnouncementListTab />}
      {activeTab === "create" && (
        <AnnouncementCreateTab onCreated={handleCreated} />
      )}
    </div>
  );
}
